// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCompanyDetails_scrollable-content__4tTpN","card":"ViewCompanyDetails_card__ssMna","ant-card-head-title":"ViewCompanyDetails_ant-card-head-title__ftCep"};